
export const INVOICE_CONFIG = {
 GOODS: {
    title: "TAX INVOICE (GOODS)",

    sections: [
      {
        sectionTitle: "Invoice Details",
        fields: [
          { key: "invoiceDate", label: "Invoice Date", type: "date", required: true },
          { key: "invoiceNo", label: "Invoice Number", type: "alphanumeric", required: true },
          { key: "dueDate", label: "Due Date", type: "date", required: false },
          { key: "customerName", label: "Customer Name", type: "string", required: true },
          { key: "customerGstin", label: "Customer GSTIN", type: "gst", required: false },
          { key: "shippingAddress", label: "Shipping Address", type: "description", rows: 1, required: false }
        ]
      },

      {
        sectionTitle: "Seller Details",
        fields: [
          { key: "sellerGstin", label: "Seller GSTIN", type: "gst", required: true },
          { key: "sellerState", label: "Seller State", type: "string", required: true },
          { key: "placeOfSupply", label: "Place of Supply", type: "string", required: true }

        ]
      },

   
    ],

    itemFields: [
      { key: "name", label: "Item Name", type: "string", required: true },
      { key: "hsn", label: "HSN Code", type: "number", required: true },
      { key: "qty", label: "Quantity", type: "number", required: true },
      { key: "unit", label: "Unit", type: "string", required: true },
      { key: "rate", label: "Rate", type: "number", required: true },
      { key: "discount", label: "Discount", type: "number", required: false },
      { key: "gstRate", label: "GST %", type: "number", required: true }
    ]
  },
  SERVICES: {
    title: "TAX INVOICE (SERVICES)",
    headerFields: [
      { key: "customerName", label: "Customer Name", type: "string", required: true },
      { key: "customerGst", label: "Customer GST", type: "gst", required: false },
      { key: "invoiceDate", label: "Invoice Date", type: "date", required: true },
      { key: "servicePeriod", label: "Service Period", type: "text", required: false },
      { key: "invoiceNo", label: "Invoice No", type: "alphanumeric", required: true },
    ],
    itemFields: [
      { key: "name", label: "Service Name", type: "string", required: true },
      { key: "sac", label: "SAC Code", type: "number", required: true },
      { key: "rate", label: "Service Amount", type: "number", required: true },
      { key: "gstRate", label: "GST %", type: "number", required: true },
    ]
  },

  EXPORT: {
    title: "EXPORT INVOICE",
    headerFields: [
      { key: "customerName", label: "Buyer Name", type: "string", required: true },
      { key: "invoiceDate", label: "Invoice Date", type: "date", required: true },
      { key: "invoiceNo", label: "Invoice No", type: "alphanumeric", required: true },
      { key: "port", label: "Port of Export", type: "string", required: true },
      { key: "shippingBill", label: "Shipping Bill No", type: "string", required: true },
    ],
    itemFields: [
      { key: "name", label: "Item Name", type: "string", required: true },
      { key: "hsn", label: "HSN Code", type: "number", required: true },
      { key: "qty", label: "Quantity", type: "number", required: true },
      { key: "rate", label: "Rate", type: "number", required: true },
    ]
  }
};
